<div>
  <!-- Header -->
  <div class="flex justify-between pb-5 sticky top-0 w-full z-30 bg-white">
    <p class="text-sm font-bold text-gray-500 m-0">
      Action counts:
      <span class="text-gray-800">{{ assignmentHistory.totalCount ?? 0 }}</span>
    </p>
  </div>

  <!-- Timeline -->
  <div class=" h-full overflow-y-auto" >
    <div class="pl-4 relative">
      <div class="space-y-4 relative h-full overflow-y-auto">
        <!-- Bold light-gray line (moved left of circles) -->
        <div class="absolute top-0 left-[6px] w-[3px] bg-gray-300 h-full"></div>

        <ng-container *ngFor="let item of assignmentHistory.data; let i = index">
          <div class="flex items-start space-x-3 relative">
            <!-- Circle -->
            <div class="relative z-10">
              <div
                class="w-4 h-4 rounded-full border-2 bg-white"
                [ngClass]="item.stateId == states.Active ? 'border-green-500' : 'border-gray-400'"
              ></div>
            </div>

            <!-- Content -->
            <div class="flex flex-col pl-1">
              <p class="text-[13px] leading-4 font-bold text-gray-800 mb-1">
                <span class="mr-3">{{ item.licensePlateNumber ?? item.driverName }}</span>
                <span *ngIf="item.stateId == states.Active" class="text-green-500"> Currently Assigned </span>
              </p>

              <!-- Light gray info text -->
              <!-- <p class="text-[12px] leading-4 font-semibold text-gray-400 mb-1">
                {{ item.vehicleAssignment }} - {{ item.vehicleStatus }}
              </p> -->

              <p class="text-[12px] leading-4 font-semibold text-gray-400 m-0">
                {{ utcToTimeZone.convertUTCToLocalTime(item.startDate, this.businessTimeZone) | date: 'MM/dd/yyyy' }} -
                {{ (utcToTimeZone.convertUTCToLocalTime(item.endDate, this.businessTimeZone) | date: 'MM/dd/yyyy') ?? '' }} 
                <span class="text-gray-600">by {{ item.createdByName }}</span>
              </p>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
